/**
 * Utilitários para renderização de ícones
 */

import React from "react";
import { resolveIconUsageToken, type IconUsageToken } from "../semantic/icons";

/**
 * Renderiza ícone Material Symbols com tokens aplicados
 * @param icon - Nome do ícone Material Symbols
 * @param usage - Contexto de uso (define tamanho automaticamente)
 * @param className - Classes CSS adicionais
 * @returns Elemento React com ícone
 * 
 * @example
 * renderMaterialIcon("check", "icon.usage.button")
 * // Retorna: <span className="material-symbols-outlined" style={{ fontSize: "24px" }}>check</span>
 */
export const renderMaterialIcon = (
  icon: string,
  usage: IconUsageToken,
  className?: string
): React.ReactNode => {
  const resolved = resolveIconUsageToken(usage);
  
  return (
    <span
      className={`material-symbols-outlined ${className || ""}`.trim()}
      style={{ fontSize: resolved.fontSize }}
      aria-hidden="true"
    >
      {icon}
    </span>
  );
};
